import { Grid } from '@mui/material';
import AutocompleteField from '../../../components/general/fields/autocompleteField';
import FieldText from '../../../components/general/fields/fieldText';
import { formatOrbitSelect } from '../utils/formatOrbitSelect';
import { OrbitSectionHeader } from '../components/orbitSectionHeader';
import { isOrbitDefensorConsumidor, ORBIT_CHANNEL_OPTIONS } from './formData';
import { useOrbitChannelForm } from './hook';
import { OrbitChannelFormProps } from '../sectionProps';
import { OrbitFormHeader } from './orbitFormHeader';

export const OrbitChannelForm = (props: OrbitChannelFormProps) => {
    const { readOnly } = props;
    const { formik } = useOrbitChannelForm(props);
    const isDefensor = isOrbitDefensorConsumidor(formik.values.orbitChannel);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <OrbitSectionHeader title="Tipo de Formulario" />
            </Grid>
            <Grid item xs={12} md={4}>
                {readOnly ? (
                    <FieldText
                        label="Tipo"
                        name="orbitChannel"
                        size="small"
                        disabled
                        value={formik.values.orbitChannel}
                    />
                ) : (
                    <AutocompleteField
                        data={formatOrbitSelect(ORBIT_CHANNEL_OPTIONS)}
                        label="Tipo"
                        name="orbitChannel"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.orbitChannel}
                        errors={formik.errors.orbitChannel}
                        value={formik.values.orbitChannel}
                        onChangeValue={(value: string) =>
                            formik.setFieldValue('orbitChannel', value)
                        }
                    />
                )}
            </Grid>
            {!readOnly && !isDefensor && (
                <OrbitFormHeader channel={formik.values.orbitChannel} />
            )}
        </Grid>
    );
};
